export const CHAT_APP_APPEARANCE_MODELS = [
  {
    key: 'lobster',
    appearanceName: 'Crab Guy',
    label: 'Lobster',
    description: 'The original clawed menace.',
    icon: '🦞',
    accent: '#fb7185',
    glow: 'rgba(251, 113, 133, 0.2)',
    glb: '/miniboys/lobster.glb',
    avatar: '/Lobster_Icon.png',
  },
  {
    key: 'hammerhead',
    appearanceName: 'MC Hammer',
    label: 'Hammerhead',
    description: 'Wide-eyed shark energy.',
    icon: '🦈',
    accent: '#53b1fd',
    glow: 'rgba(83, 177, 253, 0.2)',
    glb: '/miniboys/hammerhead.glb',
    avatar: '/Hammerhead_Icon.png',
  },
  {
    key: 'starfish',
    appearanceName: 'Patrick',
    label: 'Starfish',
    description: 'Soft chaos with a smile.',
    icon: '⭐',
    accent: '#fbbf24',
    glow: 'rgba(251, 191, 36, 0.2)',
    glb: '/miniboys/starfish.glb',
    avatar: '/Starfish_Icon.png',
  },
  {
    key: 'squid',
    appearanceName: 'Davy Jones',
    label: 'Squid',
    description: 'Tentacles, drama, excellent vibes.',
    icon: '🦑',
    accent: '#a78bfa',
    glow: 'rgba(167, 139, 250, 0.2)',
    glb: '/miniboys/squid.glb',
    avatar: '/Squid_Icon.png',
  },
];

export const CHAT_APP_MODEL_KEYS = CHAT_APP_APPEARANCE_MODELS.map((m) => m.key);

export function getChatAppModelGlb(modelKey) {
  return getChatAppAppearanceModel(modelKey).glb;
}

export function getChatAppModelAvatarUrl(modelKey) {
  const normalizedKey = String(modelKey || '').trim().toLowerCase();
  const match = CHAT_APP_APPEARANCE_MODELS.find((model) => model.key === normalizedKey);
  return match ? match.avatar : null;
}

export function getChatAppAppearanceModel(modelKey) {
  const normalizedKey = String(modelKey || '').trim().toLowerCase();
  return (
    CHAT_APP_APPEARANCE_MODELS.find((model) => model.key === normalizedKey) ||
    CHAT_APP_APPEARANCE_MODELS[0]
  );
}
